const Logo = ({ light = false, className = "h-9 md:h-10 w-auto" }) => (
  <img
    src={light ? "/images/logo-light.png" : "/images/logo.png"}
    alt="Radiant Machine Tools — Precision Engineering & Manufacturing"
    className={className}
    data-testid="brand-logo"
  />
);

export const LogoMark = ({ className = "h-8 w-auto" }) => (
  <img
    src="/images/logo-mark.png"
    alt="RMT monogram"
    className={className}
    data-testid="brand-logo-mark"
  />
);

export default Logo;
